
document.addEventListener('DOMContentLoaded', () => {


const progynyConsent = document.getElementById('progynyConsent');
const progynyContinueBtn = document.getElementById('progynyContinueBtn');

if (progynyConsent && progynyContinueBtn) {
  progynyContinueBtn.disabled = !progynyConsent.checked;

  progynyConsent.addEventListener('change', () => {
    progynyContinueBtn.disabled = !progynyConsent.checked;
  });
}   


  const panels = document.querySelectorAll('.fb__panel');
  const providerButtons = document.querySelectorAll('.fb__provider');

  function showPanel(target) {
    panels.forEach(panel => panel.classList.remove('is-active'));
    const nextPanel = document.querySelector(`[data-screen="${target}"]`);
    if (nextPanel) nextPanel.classList.add('is-active');
  }

  providerButtons.forEach(button => {
    button.addEventListener('click', () => {
      showPanel(button.getAttribute('data-target'));
    });
  });

  document.querySelectorAll('.fb__back').forEach(btn => {
    btn.addEventListener('click', () => showPanel('providers'));
  });

  const progynyForm = document.querySelector('[data-progyny-form]');
  const step2Form = document.querySelector('[data-progyny-step-2]');
  const step1Panel = document.querySelector('[data-screen="progyny"]');
  const step2Panel = document.querySelector('[data-screen="progyny-step-2"]');
  const successPanel = document.querySelector('[data-screen="success"]');

  const sameBillingCheckbox = document.getElementById('sameBilling');
  const billingFields = document.getElementById('billingFields');

  let step1Data = {};

  // =========================
  // DATE INPUT (STRICT CONTROL)
  // =========================
  function setupDateInput(input) {

    function getDaysInMonth(m, y) {
      return new Date(y || 2000, m, 0).getDate();
    }

    input.addEventListener("input", () => {
      let raw = input.value.replace(/\D/g, '').slice(0, 8);

      let m = raw.slice(0, 2);
      let d = raw.slice(2, 4);
      let y = raw.slice(4, 8);

      // Month (01–12)
      if (m.length === 1 && parseInt(m) > 1) {
        m = '0' + m;
      }
      if (m.length === 2) {
        let monthNum = Math.min(Math.max(parseInt(m), 1), 12);
        m = monthNum.toString().padStart(2, '0');
      }

      // Day (depends on month)
      if (d.length === 2) {
        const monthNum = parseInt(m) || 1;
        const yearNum = parseInt(y) || 2000;
        const maxDay = getDaysInMonth(monthNum, yearNum);

        let dayNum = Math.min(Math.max(parseInt(d), 1), maxDay);
        d = dayNum.toString().padStart(2, '0');
      }

      // Year (1900–2100)
      if (y.length === 4) {
        let yearNum = Math.min(Math.max(parseInt(y), 1900), 2100);
        y = yearNum.toString();
      }

      let formatted = m;
      if (d) formatted += '/' + d;
      if (y) formatted += '/' + y;

      input.value = formatted;
    });

    // Block non-numeric input
    input.addEventListener("keypress", (e) => {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    });

    // Final validation (visual)
    input.addEventListener("blur", () => {
      if (!input.value) return;

      if (!validateDate(input.value)) {
        input.classList.add('input-error');
      } else {
        input.classList.remove('input-error');
      }
    });
  }

  

  document.querySelectorAll('[name="date_of_birth"], [name="cycle_end_date"]').forEach(setupDateInput);

  // =========================
  // HELPERS
  // =========================

  function validateDate(dateStr) {
    const parts = dateStr.split('/');
    if (parts.length !== 3) return false;

    let [m, d, y] = parts.map(Number);

    const date = new Date(y, m - 1, d);

    return (
      date.getMonth() === m - 1 &&
      date.getDate() === d &&
      date.getFullYear() === y
    );
  }

  function parseToUTC(dateStr) {
    if (!dateStr) return null;
    const [m, d, y] = dateStr.split('/');
    return new Date(Date.UTC(y, m - 1, d)).toISOString();
  }

  function splitName(fullName) {
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ') || ''
    };
  }

  function getItems(form) {
    const items = [];

    form.querySelectorAll('input[name="product[]"]:checked').forEach(cb => {

      const variantId = cb.dataset.variantId;

      if (!variantId) return;

      items.push({
        id: variantId,
        qty: 1
      });
    });


    return items;
  }

  // =========================
  // STEP 1
  // =========================
  if (progynyForm) {
    progynyForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = Object.fromEntries(new FormData(progynyForm));
      const items = getItems(progynyForm);

      if (!validateDate(formData.date_of_birth)) {
        alert('Enter valid Date of Birth');
        return;
      }

      if (formData.cycle_end_date && !validateDate(formData.cycle_end_date)) {
        alert('Enter valid Cycle End Date');
        return;
      }

      if (items.length === 0) {
        alert('Select at least one test');
        return;
      }

      step1Data = {
        clinic: formData.clinic,
        full_name: formData.full_name,
        member_id: formData.member_id || null,
        date_of_birth: parseToUTC(formData.date_of_birth),
        cycle_type: formData.cycle_type || null,
        cycle_end_date: parseToUTC(formData.cycle_end_date),
        items
      };

      step1Panel.classList.remove('is-active');
      step2Panel.classList.add('is-active');
    });
  }

  // =========================
  // BILLING LOGIC
  // =========================
  const shippingFields = {
    country: document.querySelector('[name="country"]'),
    address: document.querySelector('[name="address"]'),
    apt: document.querySelector('[name="apt"]'),
    city: document.querySelector('[name="city"]'),
    state: document.querySelector('[name="state"]'),
    zip: document.querySelector('[name="zip"]'),
    phone: document.querySelector('[name="phone"]'),
  };

  const billingInputs = {
    country: document.querySelector('[name="billing_country"]'),
    address: document.querySelector('[name="billing_address"]'),
    apt: document.querySelector('[name="billing_apt"]'),
    city: document.querySelector('[name="billing_city"]'),
    state: document.querySelector('[name="billing_state"]'),
    zip: document.querySelector('[name="billing_zip"]'),
    phone: document.querySelector('[name="billing_phone"]'),
  };

  function copyShippingToBilling() {
    Object.keys(shippingFields).forEach(key => {
      if (shippingFields[key] && billingInputs[key]) {
        billingInputs[key].value = shippingFields[key].value;
      }
    });
  }

  function clearBillingFields() {
    Object.values(billingInputs).forEach(input => {
      if (input) input.value = '';
    });
  }

  function toggleBillingInputs(disabled) {
    Object.values(billingInputs).forEach(input => {
      if (input) input.disabled = disabled;
    });
  }

  sameBillingCheckbox?.addEventListener('change', () => {
    if (sameBillingCheckbox.checked) {
      billingFields.style.display = 'none';
      toggleBillingInputs(true);
      copyShippingToBilling();
    } else {
      billingFields.style.display = 'block';
      toggleBillingInputs(false);
      clearBillingFields();
    }
  });

  Object.values(shippingFields).forEach(input => {
    input?.addEventListener('input', () => {
      if (sameBillingCheckbox?.checked) {
        copyShippingToBilling();
      }
    });
  });

  if (sameBillingCheckbox?.checked) {
    billingFields.style.display = 'none';
    toggleBillingInputs(true);
    copyShippingToBilling();
  } else {
    billingFields.style.display = 'block';
    toggleBillingInputs(false);
  }

  // =========================
  // PAYLOAD BUILDER
  // =========================
  function buildFinalPayload(step1Data, step2Data) {
    const { firstName, lastName } = splitName(step1Data.full_name);

    const shippingAddress = {
      address1: step2Data.address,
      address2: step2Data.apt || '',
      city: step2Data.city,
      zip: step2Data.zip,
      country: step2Data.country,
      phone: step2Data.phone
    };

    const billingAddress = sameBillingCheckbox?.checked
      ? { ...shippingAddress }
      : {
          address1: step2Data.billing_address,
          address2: step2Data.billing_apt || '',
          city: step2Data.billing_city,
          zip: step2Data.billing_zip,
          country: step2Data.billing_country,
          phone: step2Data.billing_phone
        };

    return {
      entity:'progyny',
      customer: {
        firstName,
        lastName,
        email: step2Data.email,
        date_of_birth: step1Data.date_of_birth,
        phone: step2Data.phone
      },
      doctor: step1Data.clinic,
      memberId: step1Data.member_id,
      shippingAddress,
      billingAddress,
      items: step1Data.items || [],
      previousCycle: step1Data.cycle_type
        ? {
            type: step1Data.cycle_type,
            date: step1Data.cycle_end_date
          }
        : null
    };
  }
// async function handleProgynySubmit(data){
//   try {
//     const response = await fetch("https://api.sapyen.co/api/order/insurance", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-api-key":"019df253-e564-7c88-9be6-786af0800aa6",
//       },
//       body: JSON.stringify(data),
//     });

//     const result = await response.json();

//      if (!response.ok || result.success === false) {
//       throw result;
//     }

//     console.log("Success:", result);
//     return result;

//   } catch (error) {
//     console.error("Error:", error);
//     throw error;
//   }
// }

async function handleProgynySubmit(data) {
  try {
    const response = await fetch(
      "https://api.sapyen.co/api/order/insurance",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "019df253-e564-7c88-9be6-786af0800aa6",
          // 'x-api-key':'super_secret_key'
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();

    // Handle API failures
    if (!response.ok || result.success === false) {
      throw result;
    }

    return result;

  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}


  if (step2Form) {
    step2Form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const step2Data = Object.fromEntries(new FormData(step2Form));
      const finalPayload = buildFinalPayload(step1Data, step2Data);


        const errorMessage = document.querySelector(".fb__error-message");
          showLoader();

      try {
      await handleProgynySubmit(finalPayload); //API call here

      step2Panel.classList.remove('is-active');
      successPanel.classList.add('is-active');

    } catch (error) {
       console.error("Submission failed:", error);

      let message =
        error?.message ||
        error?.error ||
        error?.details ||
        error?.title ||
        "Something went wrong while submitting your request.";

      if (Array.isArray(error?.errors)) {
        message = error.errors
          .map((e) => e.message || e)
          .join(", ");
      }

      if (errorMessage) {
        errorMessage.textContent = message;
      }

      showPanel("error");;
    } finally {
      hideLoader();
    }
      // step2Panel.classList.remove('is-active');
      // successPanel.classList.add('is-active');
    });
  }

  document.querySelectorAll('.fb__done').forEach(btn => {
  btn.addEventListener('click', () => {
    showPanel('providers');
  });
});

  document.querySelectorAll('.fb__retry').forEach(btn => {
  btn.addEventListener('click', () => {
    const panel = btn.closest('[data-screen]');

    if (panel?.dataset.screen === 'win-error') {
      showPanel('win-step-2');
    } else {
      showPanel('progyny-step-2');
    }
  });
});


  function handleCheckout(button) {
  button.addEventListener('click', async (e) => {
    e.preventDefault();

    const panel = button.closest('.fb__panel');

    // only look inside THIS panel
    const selected = panel.querySelectorAll('input[name="product[]"]:checked');

    if (selected.length === 0) {
      alert('Please select at least one test');
      return;
    }

    const items = [];

    selected.forEach(cb => {
      const id = cb.dataset.variantId;

      if (id) {
        items.push({
          id: Number(id),
          quantity: 1
        });
      }
    });

    try {
      // optional UX improvement
      button.disabled = true;
      button.innerText = 'Processing...';

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      window.location.href = '/checkout';

    } catch (err) {
      console.error(err);
      alert('Something went wrong. Try again.');

      button.disabled = false;
      button.innerText = 'Order Sapyen Kit';
    }
  });
}

document.querySelectorAll('.fb__sapyen__order').forEach(handleCheckout);
});